
import React      from 'react';
import CSSModules from 'react-css-modules';

import Button           from '../Button';
import FontIcon         from '../FontIcon';
import Overlay          from '../Overlay';
import TimetableForm    from '../TimetableForm';
import YesNoOptionPanel from '../YesNoOptionPanel';

import * as timetableList from '../../actions/timetableList';

import { connect } from 'react-redux';

import style from './style.scss';

class TimetableList extends React.Component {
    
    componentDidMount() {
        
        this.props.refreshTimetables();
    }

    _getDeleteTimetableOverlayContent() {

        if (this.props.isDeleteTimetableOverlayOpen) {

            const { timetableToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the&nbsp;

                        <span styleName="timetable-name--to-delete">
                            { timetableToDelete.name }
                        </span>

                        &nbsp;timetable?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteTimetableOverlay }
                                      yes={ this.props.deleteTimetable.bind(this, timetableToDelete.id) } />

                </div>
            );
        }
    }

    render() {

        return (

            <article>

                <Overlay isOpen={ this.props.isDeleteTimetableOverlayOpen }
                         closeOverlay={ this.props.hideDeleteTimetableOverlay }
                         title="Delete Timetable"
                         size="small">

                    { this._getDeleteTimetableOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isNewTimetableOverlayOpen }
                         closeOverlay={ this.props.hideNewTimetableOverlay }
                         title="New Timetable"
                         size="medium">

                    <TimetableForm submitSuccess={ this.props.timetableCreated } />

                </Overlay>

                <Overlay isOpen={ this.props.isEditTimetableOverlayOpen }
                         closeOverlay={ this.props.hideEditTimetableOverlay }
                         title="Edit Timetable"
                         size="medium">

                    <TimetableForm submitSuccess={ this.props.timetableUpdated} />

                </Overlay>

                <Button onClick={ this.props.showNewTimetableOverlay }
                        className={ style['new-timetable-button'] }>

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New timetable</span>

                </Button>

                <section>

                    {
                        this.props.timetables.map((timetable) => {

                            return (
                                <article key={ timetable.id } styleName="timetable">

                                    <h2 styleName="timetable-heading">
                                        { timetable.name }
                                    </h2>

                                    <div styleName="timetable-action-panel">

                                        <a styleName="timetable-action" 
                                           onClick={ this.props.showEditTimetableOverlay.bind(this, timetable) }>
                                            
                                            Edit
                                        </a>

                                        <a styleName="timetable-action"
                                           onClick={ this.props.showDeleteTimetableOverlay.bind(this, timetable) }>

                                            Delete
                                        </a>

                                    </div>

                                    <table styleName="timetable-table">
                                        <tbody>

                                        {
                                            timetable.periods.map((period) => {

                                                return (
                                                    <tr key={ period.id }>

                                                        <td>{ period.time }</td>

                                                        <td dangerouslySetInnerHTML={{ __html: period.description }}></td>

                                                    </tr>
                                                );
                                            })
                                        }

                                        </tbody>
                                    </table>

                                </article>
                            );
                        })
                    }

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.timetableList;
}

function mapDispatchToProps(dispatch) {

    return {
        timetableCreated: () => {

            dispatch(timetableList.hideNewTimetableOverlay());
            dispatch(timetableList.refreshTimetables());
        },
        timetableUpdated: () => {

            dispatch(timetableList.hideEditTimetableOverlay());
            dispatch(timetableList.refreshTimetables());
        },
        hideEditTimetableOverlay: () => {

            dispatch(timetableList.hideEditTimetableOverlay());
        },
        showEditTimetableOverlay: (timetable) => {

            dispatch(timetableList.showEditTimetableOverlay(timetable));
        },
        deleteTimetable: (timetableId) => {

            dispatch(timetableList.deleteTimetable(timetableId));
        },
        showDeleteTimetableOverlay: (timetable) => {

            dispatch(timetableList.showDeleteTimetableOverlay(timetable));
        },
        hideDeleteTimetableOverlay: () => {

            dispatch(timetableList.hideDeleteTimetableOverlay());
        },
        refreshTimetables: () => {

            dispatch(timetableList.refreshTimetables());
        },
        hideNewTimetableOverlay: () => {

            dispatch(timetableList.hideNewTimetableOverlay());
        },
        showNewTimetableOverlay: () => {

            dispatch(timetableList.showNewTimetableOverlay());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(TimetableList, style));


// WEBPACK FOOTER //
// ./components/TimetableList/index.js